module.exports = __webpack_public_path__ + "img/joice-kelly-PFN8tB5iGEA-unsplash-r.8ee8c864.jpg";